import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { acceptJson } from '../shared.js';
import { placePredictionsResponseSpec } from './specs.js';

const getPlacePredictions = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return validateResponse(placePredictionsResponseSpec, (yield fetch(`${apiUrl}/place/predictions?name=${request.place}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function getPlacePredictions(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getPlacePredictions };
//# sourceMappingURL=place-predictions.js.map
